export default {
  allLocations: (state) => state.locations,
  allLocationsByAccountId: (state) => state.locationsByAccountId,
  locationsLoading: (state) => state.loading
}
